// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"43a3fc10","169":"c4e2d9b7","246":"05acb8b4","346":"a9dfa952","378":"26726f59","430":"05d6b1e9","447":"efd50c81","453":"c53c9402","630":"4f78a3c3","635":"15d9e22a","810":"2083a07c"}[chunkId] + ".chunk.js";
};